
<template>
  <main v-if="progress" class="founder-journey mt-12">
    <div class="flex justify-between mb-10">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Data Request 4</h1>
    </div>
    <div v-show="progress.stage_eight === 'New'">
      <div class="flex flex-col xl:flex-row justify-between pt-4 text-sm text-gray-500">
        <div class="mr-16 mb-4">
          <h3 class="font-Rubik text-[18px] leading-[21.33px] font-medium text-black">Post Call Data Request</h3>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Kindly provide all the required information to proceed to the next stage.</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-light w-[303px] mt-3">Click on the save draft button to save your progress</p>
          <p class="font-Rubik text-[16px] leading-[24px] font-normal w-[303px] mt-2">Estimated completion time: <span class="text-black">5mins</span></p>
          <p class="font-Rubik text-[14px] leading-[24px] font-normal text-red-400 mt-2">*Required</p>
        </div>
        <div class="flex flex-col flex-grow lg:pb-10 pb-8">
          <div class="max-w-[613px]">
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
              >
                Customer Reference Calls (Add five)
              </label>
              <div v-for="(customerReference, index) in data.customer_references" :key="index" class="relative grid md:grid-cols-2 grid-cols-1 md:gap-2 w-full mt-2 md:mb-0 mb-6">
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="full-name"
                  >
                    <span class="text-red-400">*</span>
                    FULL NAME [{{index + 1}}]
                  </label>
                  <input
                    id="refreeName"
                    name="refreeName"
                    type="text"
                    :class="[
                    (v$.customer_references.$each.$response.$data[index].name.$error && v$.customer_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="Refree Name"
                    style="transition: 'all .15s ease'"
                    v-model="v$.customer_references.$model[index].name"
                    @blur="v$.customer_references.$touch()"
                  />
                  <div v-if="v$.customer_references.$each.$response.$data[index].name.$error && v$.customer_references.$dirty">
                    <p
                      v-if="v$.customer_references.$each.$response.$data[index].name.$invalid && v$.customer_references.$each.$response.$data[index].name.alpha"
                      class="text-red-400 text-[10px] font-light"
                    >Refree name is required</p>
                    <p
                      v-if="!v$.customer_references.$each.$response.$data[index].name.alpha"
                      class="text-red-400 text-[10px] font-light"
                    >Full name should contain first and last name</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="part-time"
                  >
                    <span class="text-red-400">*</span>
                    PRIMARY CONTACT EMAIL [{{index + 1}}]
                  </label>
                  <div class="relative">
                    <span v-if="index > 0" @click="removeField(data.customer_references, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                      <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </span>
                    <input
                      id="refreeEmail"
                      name="refreeEmail"
                      type="email"
                      :class="[
                      (v$.customer_references.$each.$response.$data[index].primary_email.$error && v$.customer_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                      ]"
                      class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                      placeholder="tonicampbell@example.com"
                      style="transition: 'all .15s ease'"
                      v-model="v$.customer_references.$model[index].primary_email"
                      @blur="v$.customer_references.$touch()"
                    />
                    <div v-if="v$.customer_references.$each.$response.$data[index].primary_email.$error && v$.customer_references.$dirty">
                      <p
                        v-if="v$.customer_references.$each.$response.$data[index].primary_email.$invalid"
                        class="text-red-400 text-[10px] font-light"
                      >Refree email is required</p>
                      <p
                        v-if="v$.customer_references.$each.$response.$data[index].primary_email.email.$invalid"
                        class="text-red-400 text-[10px] font-light"
                      >Email is invalid</p>
                    </div>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="part-time"
                  >
                    <span class="text-red-400">*</span>
                    PHONE NUMBER [{{index + 1}}]
                  </label>
                  <input
                    id="refreePhone"
                    name="refreePhone"
                    type="number"
                    :class="[
                    (v$.customer_references.$each.$response.$data[index].phone_number.$error && v$.customer_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="08039009334"
                    style="transition: 'all .15s ease'"
                    v-model="v$.customer_references.$model[index].phone_number"
                    @blur="v$.customer_references.$touch()"
                  />
                  <div v-if="v$.customer_references.$each.$response.$data[index].phone_number.$error && v$.customer_references.$dirty">
                    <p
                      v-if="v$.customer_references.$each.$response.$data[index].phone_number.$invalid && v$.customer_references.$each.$response.$data[index].phone_number.minValueValue"
                      class="text-red-400 text-[10px] font-light"
                    >Refree contact is required</p>
                    <p
                      v-if="v$.customer_references.$each.$response.$data[index].phone_number.minValueValue === false"
                      class="text-red-400 text-[10px] font-light"
                    >The minimum value allowed is 0</p>
                  </div>
                </div>
              </div>
              <div v-show="data.customer_references.length < 5" @click="addNewField(data.customer_references)" class="flex items-center text-blueLink cursor-pointer">
                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                </svg>
                <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another reference</p>
              </div>
            </div>

            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
              >
                Founder References (Add three)
              </label>
              <div v-for="(founderReference, index) in data.founder_references" :key="index" class="relative grid md:grid-cols-2 grid-cols-1 md:gap-2 w-full mt-2 md:mb-0 mb-6">
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="full-name"
                  >
                    <span class="text-red-400">*</span>
                    FULL NAME [{{index + 1}}]
                  </label>
                  <input
                    id="founderName"
                    name="founderName"
                    type="text"
                    :class="[
                    (v$.founder_references.$each.$response.$data[index].name.$error && v$.founder_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="Founder"
                    style="transition: 'all .15s ease'"
                    v-model="v$.founder_references.$model[index].name"
                    @blur="v$.founder_references.$touch()"
                  />
                  <div v-if="v$.founder_references.$each.$response.$data[index].name.$error && v$.founder_references.$dirty">
                    <p
                      v-if="v$.founder_references.$each.$response.$data[index].name.$invalid && v$.founder_references.$each.$response.$data[index].name.alpha"
                      class="text-red-400 text-[10px] font-light"
                    >Founder name is required</p>
                    <p
                      v-if="!v$.founder_references.$each.$response.$data[index].name.alpha"
                      class="text-red-400 text-[10px] font-light"
                    >Full name should contain first and last name</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="part-time"
                  >
                    <span class="text-red-400">*</span>
                    PRIMARY CONTACT EMAIL [{{index + 1}}]
                  </label>
                  <div class="relative">
                    <span v-if="index > 0" @click="removeField(data.founder_references, index)" class="absolute inset-y-0 right-0 flex items-center pr-4 mt-2 h-[max-content] transform translate-y-[15px]">
                      <svg class="h-5 w-5 text-black cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </span>
                    <input
                      id="founderEmail"
                      name="founderEmail"
                      type="email"
                      :class="[
                      (v$.founder_references.$each.$response.$data[index].primary_email.$error && v$.founder_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                      ]"
                      class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                      placeholder="founder@example.com"
                      style="transition: 'all .15s ease'"
                      v-model="v$.founder_references.$model[index].primary_email"
                      @blur="v$.founder_references.$touch()"
                    />
                    <div v-if="v$.founder_references.$each.$response.$data[index].primary_email.$error && v$.founder_references.$dirty">
                      <p
                        v-if="v$.founder_references.$each.$response.$data[index].primary_email.$invalid"
                        class="text-red-400 text-[10px] font-light"
                      >Founder email is required</p>
                    </div>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="part-time"
                  >
                    <span class="text-red-400">*</span>
                    PHONE NUMBER [{{index + 1}}]
                  </label>
                  <input
                    id="founderPhone"
                    name="founderPhone"
                    type="number"
                    :class="[
                    (v$.founder_references.$each.$response.$data[index].phone_number.$error && v$.founder_references.$dirty) ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="09037357845"
                    style="transition: 'all .15s ease'"
                    v-model="v$.founder_references.$model[index].phone_number"
                    @blur="v$.founder_references.$touch()"
                  />
                  <div v-if="v$.founder_references.$each.$response.$data[index].phone_number.$error && v$.founder_references.$dirty">
                    <p
                      v-if="v$.founder_references.$each.$response.$data[index].phone_number.$invalid && v$.founder_references.$each.$response.$data[index].phone_number.minValueValue"
                      class="text-red-400 text-[10px] font-light"
                    >Founder contact is required</p>
                    <p
                      v-if="v$.founder_references.$each.$response.$data[index].phone_number.minValueValue === false"
                      class="text-red-400 text-[10px] font-light"
                    >The minimum value allowed is 0</p>
                  </div>
                </div>
              </div>
              <div v-show="data.founder_references.length < 3" @click="addNewField(data.founder_references)" class="flex items-center text-blueLink cursor-pointer">
                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd" />
                </svg>
                <p class="text-[12px] font-Rubik leading-[14.22px]">Click here to add another reference</p>
              </div>
            </div>

            <div class="relative w-full mb-6">
              <div
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
              >
                <span class="text-red-400">*</span>
                Last three months bank statements
              </div>
              <div class="flex md:items-center items-start md:flex-row flex-col relative">
                <label for="bankstatement" class="flex flex-nowrap items-center justify-center px-2 py-3 w-[40%] relative cursor-pointer bg-white font-Rubik text-black rounded-sm border border-dashed focus:outline-none focus:border-black hover:border-black focus:ring-0">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </span>
                  Upload a File
                  <input id="bankstatement" name="bank_statement" type="file" class="sr-only"
                  @change="choosefile($event, 'bank_statement', 'FINANCIAL')"
                  :disabled="loading.state">
                </label>
                <!-- loading -->
                <svg v-if="loading.state && loading.data === 'bank_statement'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" fill="none" stroke="#000000" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                  </circle>
                </svg>
                <div v-else class="md:ml-5 md:mt-0 mt-4 ml-0 text-blueLink flex items-center justify-between flex-nowrap md:w-[60%] w-full">
                  <span v-if="data.bank_statement" class="mr-3">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_563_5436)">
                        <path d="M1.80078 1.8C1.80078 0.805888 2.60667 0 3.60078 0H10.8008C11.0395 0 11.2684 0.0948211 11.4372 0.263604L15.9372 4.7636C16.106 4.93239 16.2008 5.1613 16.2008 5.4V16.2C16.2008 17.1941 15.3949 18 14.4008 18H3.60078C2.60667 18 1.80078 17.1941 1.80078 16.2V1.8ZM14.028 5.4L10.8008 2.17279V5.4H14.028ZM9.00078 1.8L3.60078 1.8V16.2H14.4008V7.2H9.90078C9.40372 7.2 9.00078 6.79706 9.00078 6.3V1.8ZM5.40078 9.9C5.40078 9.40294 5.80372 9 6.30078 9H11.7008C12.1978 9 12.6008 9.40294 12.6008 9.9C12.6008 10.3971 12.1978 10.8 11.7008 10.8H6.30078C5.80372 10.8 5.40078 10.3971 5.40078 9.9ZM5.40078 13.5C5.40078 13.0029 5.80372 12.6 6.30078 12.6H11.7008C12.1978 12.6 12.6008 13.0029 12.6008 13.5C12.6008 13.9971 12.1978 14.4 11.7008 14.4H6.30078C5.80372 14.4 5.40078 13.9971 5.40078 13.5Z" fill="black"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_563_5436">
                          <rect width="18" height="18" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                  <div class="flex items-center justify-between w-full relative">
                    <p class="font-Rubik">{{data.bank_statement}}</p>
                    <span v-if="data.bank_statement" @click="removefile('bank_statement')" class="flex items-center pr-4">
                      <svg class="h-5 w-5 text-originsRed cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="relative w-full mb-6">
              <label
                class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal mb-2"
              >
                Financing wire instructions
              </label>
              <div class="relative grid md:grid-cols-2 grid-cols-1 md:gap-2 w-full mb-6 mt-2">
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="bank-name"
                  >
                    <span class="text-red-400">*</span>
                    BANK NAME
                  </label>
                  <input
                    id="bank-name"
                    name="bank-name"
                    type="text"
                    :class="[
                    v$.bank_name.$error ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="Keystone Bank"
                    style="transition: 'all .15s ease'"
                    v-model="v$.bank_name.$model"
                    @blur="v$.bank_name.$touch()"
                  />
                  <div v-if="v$.bank_name.$error">
                    <p
                      v-if="v$.bank_name.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Bank name is required</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="bank-address"
                  >
                    <span class="text-red-400">*</span>
                    BANK ADDRESS
                  </label>
                  <input
                    id="bank-address"
                    name="bank-address"
                    type="text"
                    :class="[
                    v$.bank_address.$error ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="Lekki, Lagos"
                    style="transition: 'all .15s ease'"
                    v-model="v$.bank_address.$model"
                    @blur="v$.bank_address.$touch()"
                  />
                  <div v-if="v$.bank_address.$error">
                    <p
                      v-if="v$.bank_address.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Bank address is required</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="swift"
                  >
                    <span class="text-red-400">*</span>
                    SWIFT CODE
                  </label>
                  <input
                    id="swift"
                    name="swift"
                    type="text"
                    :class="[
                    v$.swift_code.$error ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="RSA4467"
                    style="transition: 'all .15s ease'"
                    v-model="v$.swift_code.$model"
                    @blur="v$.swift_code.$touch()"
                  />
                  <div v-if="v$.swift_code.$error">
                    <p
                      v-if="v$.swift_code.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Swift code is required</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="account-number"
                  >
                    <span class="text-red-400">*</span>
                    ACCOUNT NUMBER
                  </label>
                  <input
                    id="account-number"
                    name="account-number"
                    type="number"
                    :class="[
                    v$.account_number.$error ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="29009334"
                    style="transition: 'all .15s ease'"
                    v-model="v$.account_number.$model"
                    @blur="v$.account_number.$touch()"
                  />
                  <div v-if="v$.account_number.$error">
                    <p
                      v-if="v$.account_number.$invalid && !v$.account_number.minValueValue.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Account number is required</p>
                    <p
                      v-if="v$.account_number.minValueValue.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >{{v$.account_number.minValueValue.$message}}</p>
                  </div>
                </div>
                <div class="md:mr-2 mb-2 w-full">
                  <label
                    class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal"
                    for="payment-reference"
                  >
                    <span class="text-red-400">*</span>
                    PAYMENT REFERENCE
                  </label>
                  <input
                    id="payment-reference"
                    name="payment-reference"
                    type="text"
                    :class="[
                    v$.payment_reference.$error ? 'border-red-400' : 'border-grey-300'
                    ]"
                    class="px-4 py-4 mt-2 text-[15px] leading-[17.78px] font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[2px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0"
                    placeholder="xyzfinanceinstructions"
                    style="transition: 'all .15s ease'"
                    v-model="v$.payment_reference.$model"
                    @blur="v$.payment_reference.$touch()"
                  />
                  <div v-if="v$.payment_reference.$error">
                    <p
                      v-if="v$.payment_reference.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Payment preference is required</p>
                    <p
                      v-if="v$.payment_reference.minLengthValue.$invalid"
                      class="text-red-400 text-[10px] font-light"
                    >Payment reference should be at least 3 characters long</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="relative w-full mb-6">
              <label class="font-Rubik text-greyText text-[14px] leading-[16.59px] font-normal">
                <span class="text-red-400">*</span>
                Do we have your consent to perform a background check?</label>
              <fieldset class="mt-4">
                <div class="space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                  <div class="flex items-center md:ml-2">
                    <input id="yes" name="background-check-consent" type="radio" checked value="Yes" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.background_check_consent">
                    <label for="yes" class="ml-3 block text-sm font-medium text-gray-700">
                      Yes
                    </label>
                  </div>
                  <div class="flex items-center">
                    <input id="no" name="background-check-consent" type="radio" value="No" class="focus:ring-1 focus:ring-black h-4 w-4 text-black border-gray-600" v-model="data.background_check_consent">
                    <label for="no" class="ml-3 block text-sm font-medium text-gray-700">
                      No
                    </label>
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="relative flex justify-end w-full mb-6">
              <button
                class="flex items-center justify-center bg-faintGrey text-black rounded-[6px] md:text-[16px] text-[14px] md:leading-[24px] leading-[20px] font-Rubik px-[28px] py-[14px] md:max-w-[157px] w-full outline-none focus:outline-none disabled:opacity-50 mr-8"
                @click="onSaveDraft"
              >
                Save draft
              </button>
              <button :disabled="checkValidForm(v$, 'Data Request 4')"
                @click="onSubmit"
                class="flex items-center justify-center bg-black text-white rounded-[6px] text-[16px] font-Rubik px-[28px] py-[14px] md:max-w-[118px] w-full outline-none focus:outline-none disabled:opacity-50">
                <span :class="submitloading ? 'mr-2' : 'mr-0'" class="text-white">Submit</span>
                <svg v-if="submitloading" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="background: none; display: block; shape-rendering: auto;" width="20px" height="20px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                  <circle cx="50" cy="50" fill="none" stroke="#ffffff" stroke-width="10" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                  </circle>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_eight === 'Processing'">
      <div class="flex items-center justify-center w-full min-h-[370px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0578 26.2933L14.5822 23.4978C12.92 26.5956 11.9378 30.1467 11.9378 34C11.9378 39.2133 13.7511 44.0489 16.8489 47.8267L7.63111 48.1289L9.21778 57.1956C3.55111 51.1511 0 42.9911 0 34C0 27.4267 1.88889 21.2311 5.13778 16.0178L1.58667 13.2222L17.4533 10.5022L18.0578 26.2933ZM49.8667 41.6311L53.3422 44.4267C55.0044 41.3289 55.9867 37.7778 55.9867 33.9244C55.9867 28.7111 54.1733 23.8756 51.0756 20.0978L60.3689 19.7956L58.7822 10.8044C64.4489 16.8489 68 25.0089 68 34C68 40.5733 66.1111 46.7689 62.8622 51.9822L66.4133 54.7778L50.5467 57.4978L49.8667 41.6311ZM41.6311 18.0578L44.4267 14.5822C41.3289 12.92 37.7778 11.9378 33.9244 11.9378C28.7111 11.9378 23.8756 13.7511 20.0978 16.8489L19.7956 7.63111L10.8044 9.21778C16.8489 3.55111 25.0089 0 34 0C40.5733 0 46.7689 1.88889 51.9822 5.13778L54.7778 1.58667L57.4978 17.4533L41.6311 18.0578ZM26.2933 49.8667L23.4978 53.4178C26.5956 55.08 30.1467 56.0622 34 56.0622C39.2133 56.0622 44.0489 54.2489 47.8267 51.1511L48.1289 60.3689L57.12 58.7822C51.0756 64.4489 42.9156 68 33.9244 68C27.3511 68 21.1556 66.1111 15.9422 62.8622L13.1467 66.4133L10.4267 50.5467L26.2933 49.8667Z" fill="#B5B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">The documents provided within this stage are still being processed</p>
        </div>
      </div>
    </div>
    <div v-show="progress.stage_eight ===  'Approved'">
      <div class="my-[120px]">
        <div class="flex flex-col justify-center items-center">
          <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M86.05 49.1344L84.3955 46.8684C83.0287 44.9981 83.0107 42.4624 84.3415 40.5561L85.9601 38.2721C87.8304 35.6105 86.9672 31.9238 84.0897 30.3772L81.626 29.0464C79.5758 27.9494 78.4608 25.6654 78.8384 23.3815L79.306 20.6119C79.8456 17.4108 77.4537 14.4435 74.1986 14.3176L71.3931 14.1917C69.0732 14.1018 67.077 12.5192 66.4296 10.2892L65.6563 7.5916C64.7571 4.46241 61.3221 2.84386 58.3188 4.1387L55.7471 5.2537C53.6071 6.17088 51.1433 5.63136 49.5787 3.88692L47.7083 1.80079C45.5323 -0.627032 41.7377 -0.591065 39.5976 1.85474L37.7633 3.97684C36.2346 5.72128 33.7708 6.31475 31.6307 5.43354L29.0411 4.37249C26.0378 3.1316 22.6208 4.8041 21.7576 7.95128L21.0203 10.6489C20.4268 12.9148 18.4665 14.5154 16.1466 14.6413L13.3411 14.8031C10.0861 14.983 7.74815 17.9863 8.34162 21.1694L8.84517 23.921C9.25879 26.2049 8.17976 28.5069 6.14758 29.6219L3.70177 30.9886C0.860321 32.5712 0.0330622 36.2759 1.95734 38.9015L3.61186 41.1675C4.97863 43.0378 4.99661 45.5736 3.66581 47.4799L2.04726 49.7638C0.176933 52.4254 1.04016 56.1121 3.91758 57.6587L6.38137 58.9895C8.43154 60.0866 9.54654 62.3705 9.16888 64.6545L8.68331 67.406C8.14379 70.6071 10.5357 73.5745 13.7907 73.7004L16.5962 73.8263C18.9161 73.9162 20.9124 75.4988 21.5598 77.7288L22.3331 80.4263C23.2323 83.5555 26.6672 85.1741 29.6705 83.8792L32.2422 82.7642C34.3823 81.8471 36.8461 82.3866 38.4107 84.113L40.281 86.1992C42.457 88.627 46.2517 88.591 48.3917 86.1452L50.2261 84.0231C51.7547 82.2787 54.2185 81.6852 56.3586 82.5664L58.9483 83.6275C61.9516 84.8684 65.3685 83.1959 66.2317 80.0487L66.9691 77.3511C67.5805 75.1211 69.5588 73.5205 71.8787 73.3767L74.6842 73.2148C77.9393 73.035 80.2772 70.0317 79.6837 66.8485L79.1801 64.097C78.7665 61.813 79.8455 59.5111 81.8777 58.3961L84.3235 57.0293C87.147 55.4827 87.9563 51.76 86.05 49.1344ZM44.0037 72.4235C28.3217 72.4235 15.6071 59.7089 15.6071 44.027C15.6071 28.345 28.3217 15.6304 44.0037 15.6304C59.6856 15.6304 72.4002 28.345 72.4002 44.027C72.4002 59.7089 59.6856 72.4235 44.0037 72.4235Z" fill="#40B540"/>
            <path d="M40.3707 44.7821L37.8529 42.2464C36.3603 40.7357 33.9144 40.7357 32.4038 42.2284C30.8932 43.721 30.8932 46.1668 32.3858 47.6775L34.9036 50.2132L37.709 53.0187C39.1657 54.4934 41.5396 54.4934 43.0143 53.0367L45.8198 50.2492L55.603 40.5199C57.1137 39.0272 57.1137 36.5814 55.621 35.0708C54.1283 33.5601 51.6825 33.5601 50.1719 35.0528L40.3707 44.7821Z" fill="#40B540"/>
          </svg>
          <p class="w-[210px] mt-4 font-Rubik text-[13px] leading-[20px] text-greyText text-center">You have completed this stage of the diligence process</p>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import { computed, reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { helpers, required, url, email, minValue, minLength } from '@vuelidate/validators'
import { useStore } from 'vuex'
import FileService from '@/services/file.service'
import Helpers from '../../utils/helpers'
import StageEightService from '@/services/stageeight.service'
import CompanyService from '@/services/company.service'
import store from '@/store'
import DraftService from '../../services/draft.service'

const fetchCompany = async () => {
  try {
    const staleDisabled = {
      onboarding: false,
      stage_one: true,
      stage_two: true,
      stage_three: true,
      stage_four: true,
      stage_five: true,
      stage_six: true,
      stage_seven: true,
      stage_eight: true,
      feedback_survey: true
    }
    if (store.state.app.company) {
      const id = store.state.app.company.id
      const response = await CompanyService.fetchSingleCompany(id)
      if (response.status === 200 && response.data.status === 'success') {
        const disbaled = response.data.data.disabled
        return disbaled
      }
    } else return staleDisabled
  } catch (e) {
    return false
  }
}
const current = 2
const alpha = helpers.regex(/^[a-zA-Z]{2,}\s[a-zA-Z]{2,}$/)

export default {
  async beforeRouteEnter (to, from) {
    // console.log(to.name)
    const response = await fetchCompany()
    if (!response) {
      return false
    }
    const answer = Helpers.getStageByDisabledName(to.name, response)
    store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
    if (answer.status) {
      return { name: 'Deligence' }
    }
  },
  setup () {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const submitloading = ref(false)

    const fetchCompanyData = async () => {
      try {
        const id = store.state.app.company.id
        const response = await CompanyService.fetchSingleCompany(id)
        if (response.status === 200 && response.data.status === 'success') {
          const disbaled = response.data.data.disabled
          // store.dispatch('setDisabledModal', { status: disbaled.stage_three, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
          return disbaled
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }

    onBeforeRouteLeave(async (to, from) => {
      if (to.name === 'SignIn' || to.name === 'Home' || to.name === 'Impact Assessment' || to.name === 'SDG Alignment' || to.name === 'Financial' || to.name === 'Integrations' || to.name === 'User Details') {
        return true
      }
      const response = await fetchCompanyData()
      if (!response) {
        return false
      }
      const answer = Helpers.getStageByDisabledName(to.name, response)
      store.dispatch('setDisabledModal', { status: answer.status, message: 'You currently dont have permissions to view this stage. Keep checking your mailbox for an approval of your previous submission.' })
      if (answer.status) {
        return false
      }
    })

    const stageFiles = ref({
      bank_statement: null
    })

    const loading = reactive({
      state: false,
      data: null,
      index: null
    })

    const choosefile = async (event, name, category) => {
      // console.log(event)
      loading.state = true
      loading.data = name
      const company_id = store.state.app.company.id
      if (event.target.files[0]) {
        const file = event.target.files[0]
        const formData = new FormData()
        formData.append('company_id', company_id)
        formData.append('document_type', category)
        formData.append('file', file)

        try {
          const response = await FileService.upload(formData)
          // console.log(response)
          if (response.status === 200 && response.data.status === 'success') {
            loading.state = false
            loading.data = null
            data[name] = response.data.data.file_name
            stageFiles.value[name] = response.data.data.file_name
          }
        } catch (error) {
          // console.log(error.response)
          loading.state = false
          loading.data = null
        }
      }
    }

    const removefile = (name) => {
      if (name) {
        data[name] = ''
      }
    }

    function getLocation () {
      const locationinput = document.getElementById('bank-address')
      // eslint-disable-next-line no-undef
      const loc = new google.maps.places.Autocomplete(locationinput)
      loc.addListener('place_changed', () => {
        const place = loc.getPlace()
        // console.log(place)
        const filteredPlace = Helpers.extractAddress(place)
        // console.log(filteredPlace)
        // data.location = filteredPlace.formatted_address
        data.bank_address = filteredPlace.address
        // data.coordinates = filteredPlace.coordinates
        // console.log(data)
      })
    }

    const getDraft = async () => {
      const id = store.state.app.company.id
      try {
        const response = await DraftService.getDraft(id, 'STAGE 8')
        if (response.status === 200 && response.data.status === 'success' && response.data.data !== null) {
          const draft = response.data.data
          data.customer_references = draft.customer_references
          data.founder_references = draft.founder_references
          data.bank_statement = draft.bank_statement
          data.bank_name = draft.bank_name
          data.bank_address = draft.bank_address
          data.swift_code = draft.swift_code
          data.account_number = draft.account_number
          data.payment_reference = draft.payment_reference
          data.background_check_consent = draft.background_check_consent
        }
      } catch (e) {
        Helpers.processError(e, store, router)
      }
    }
    getDraft()

    const saveDraftLoading = ref(false)
    const onSaveDraft = async () => {
      saveDraftLoading.value = true
      const stagedata = {
        customer_references: data.customer_references,
        founder_references: data.founder_references,
        bank_statement: data.bank_statement,
        bank_name: data.bank_name,
        bank_address: data.bank_address,
        swift_code: data.swift_code,
        account_number: data.account_number,
        payment_reference: data.payment_reference,
        background_check_consent: data.background_check_consent
      }
      const draft = {
        company_id: company_id,
        stage: 'STAGE 8',
        data: stagedata
      }
      console.log(draft)
      try {
        const response = await DraftService.saveDraft(draft)
        if (response.status === 200 && response.data.status === 'success') {
          const success = {
            status: true,
            message: 'Draft has been successfully saved',
            color: 'green',
            type: 'success'
          }
          store.dispatch('setAlert', success)
          setTimeout(() => {
            store.dispatch('setAlert', {
              status: false,
              message: null,
              color: null,
              type: null
            })
          }, 2000)
        }
      } catch (e) {
        saveDraftLoading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const data = reactive({
      customer_references: [
        {
          name: '',
          primary_email: '',
          phone_number: ''
        }
      ],
      founder_references: [
        {
          name: '',
          primary_email: '',
          phone_number: ''
        }
      ],
      bank_statement: '',
      bank_name: '',
      bank_address: '',
      swift_code: '',
      account_number: '',
      payment_reference: '',
      background_check_consent: 'Yes'
    })
    const rules = computed(() => ({
      customer_references: {
        $each: helpers.forEach({
          name: { required, alpha },
          primary_email: { required, email },
          phone_number: {
            required,
            minValueValue: minValue(0)
          }
        })
      },
      founder_references: {
        $each: helpers.forEach({
          name: { required, alpha },
          primary_email: { required },
          phone_number: {
            required,
            minValueValue: minValue(0)
          }
        })
      },
      bank_statement: { required },
      bank_name: { required, minLengthValue: minLength(3) },
      bank_address: { required },
      swift_code: { required },
      account_number: {
        required,
        minValueValue: minValue(0)
      },
      payment_reference: { required, minLengthValue: minLength(3) }
    }))

    const v$ = useVuelidate(rules, data)

    const addNewField = (arr) => {
      arr.push({
        name: '',
        primary_email: '',
        phone_number: ''
      })
    }
    const removeField = (arr, index) => {
      arr.splice(index, 1)
    }

    const checkValidForm = (v$, screen) => {
      switch (screen) {
        case 'Data Request 4':
          if ((v$.customer_references.$invalid ||
          data.customer_references.length < 5) ||
          (v$.founder_references.$invalid ||
          data.founder_references.length < 3) ||
          v$.bank_statement.$invalid ||
          v$.bank_name.$invalid ||
          v$.bank_address.$invalid ||
          v$.swift_code.$invalid ||
          v$.account_number.$invalid ||
          v$.payment_reference.$invalid) {
            return true
          }
          break
        default:
          return false
      }
    }

    const user_id = store.state.auth.user.id
    const company_id = store.state.app.company.id
    const onSubmit = async () => {
      const stagedata = {
        user_id: user_id,
        company_id: company_id,
        customer_ref: data.customer_references,
        founder_ref: data.founder_references,
        bank_statement: Helpers.changeEmptyStringtoNull(data.bank_statement),
        bank_name: data.bank_name,
        bank_address: data.bank_address,
        swiftcode: data.swift_code,
        accountno: data.account_number.toString(),
        payment_ref: data.payment_reference,
        background_check: data.background_check_consent
      }
      try {
        const response = await StageEightService.createStageEight(stagedata)
        if (response.status === 200 && response.data.status === 'success') {
          submitloading.value = false
          const success = {
            status: true,
            message: 'Your data has been submitted successfully. We will review and reach out to you within the next 24 to 48 hours. '
          }
          store.commit('setSuccess', success)

          store.commit('setCompany', response.data.data.company)
          store.commit('setProgress', response.data.data.progress)
        }
      } catch (e) {
        submitloading.value = false
        Helpers.processError(e, store, router)
      }
    }

    return {
      route,
      progress: computed(() => store.state.app.progress_status),
      current,
      choosefile,
      removefile,
      getLocation,
      v$,
      url,
      email,
      addNewField,
      removeField,
      data,
      stageFiles,
      loading,
      submitloading,
      checkValidForm,
      onSubmit,
      onSaveDraft
    }
  }
}
</script>

<style scoped>
</style>
